import React, { useState } from "react";

import Box from "@mui/material/Box";

import loadingGif from "@app/analytics/assets/welcomeLoading.gif";
import useTimeout from "@app/common/hooks/useTimeout";

import {
  StepCardContent,
  StepDescription,
  StepHeader,
  StepTitle,
} from "./styles";

const LoadingStep = () => {
  const [show, setShow] = useState(false);

  // Delay the loading screen for 500ms to mitigate the probability of a flash of content
  useTimeout(() => setShow(true), 500);

  if (!show) return null;

  return (
    <StepCardContent spacing="40px">
      <StepHeader>
        <StepTitle>We're glad you're here!</StepTitle>
        <StepDescription>Configuring your account...</StepDescription>
      </StepHeader>
      <Box
        component="img"
        src={loadingGif}
        alt="Loading"
        sx={{ width: "40px", height: "40px" }}
      />
    </StepCardContent>
  );
};

export default LoadingStep;
